<template>
  <div id="data-list-list-view" class="data-list-container">
    <muckType-side-view
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
      :projectId="selectedProjectId"
      @onMuckTypeUpdated="muckTypeUpdated"
      @onMuckTypeInserted="muckTypeInserted"
    />
    <vx-card ref="listCard" :title="$t('GradeControl.MuckType.Title')" title-color="black" refresh-content-action @refresh="refreshMuckTypeList"> 
      <vs-row vs-type="flex" vs-justify="flex-end">
            <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="12">
              <vs-button class="mr-3 mb-5" type="border" icon-pack="feather" icon="icon-plus" color="primary" @click="addNewData">{{$t('AddNew')}}</vs-button>
            </vs-col>
         </vs-row>
      <vs-table
            ref="table"
            v-model="selected"
            :data="muckTypes"
          >

        <template slot="thead">
          <vs-th sort-key="name">{{$t('GradeControl.MuckType.Name')}}</vs-th>
          <vs-th sort-key="code">{{$t('GradeControl.MuckType.Code')}}</vs-th>
          <vs-th sort-key="factor">{{$t('GradeControl.MuckType.Factor')}}</vs-th>
          <vs-th>{{$t('Action')}}</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td width="250px;">
                <p class="font-medium truncate">{{ tr.name }}</p>
              </vs-td>
              <vs-td width="150px;">
                <p class="font-medium truncate">{{ tr.code }}</p>
              </vs-td>
              <vs-td>
                <p class="font-medium truncate">{{ tr.factor }}</p>
              </vs-td>
              <vs-td width="100px" class="whitespace-no-wrap">
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  @click.stop="editData(tr)"
                />
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="openDeleteConfirm(tr.muckTypeId, tr.code)"
                />
              </vs-td>
              <template class="expand-muckType" slot="expand">
                <div class="con-expand-muckTypes">
                  <div class="con-btns-muckType">
                    <div class="con-muckTypex">
                      <form-label>{{$t('GradeControl.MuckType.Comments')}} </form-label>
                      <div class="con-muckType-comments">
                        {{ tr.comments }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>
<script>

import muckTypeSideView from "./components/muckTypeSideView.vue";
import moduleGradeControl from "@/store/geo/gradecontrol/moduleGradeControl.js";
import { FormLabel } from "./../../../../shared/components";


export default {
  components: {
    muckTypeSideView,
    FormLabel
  },
  data() {
    return {
      selected: [],
      selectedProjectId: null,
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {}
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    muckTypes() {
      return this.$store.state.gradeControl.muckTypes;
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.locations.length;
    }
  },
  methods: {
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    openDeleteConfirm(id, code) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: code,
        text: this.$t('GradeControl.MuckType.ConfirmDelete', { code }),
        accept: this.deleteData,
        parameters: id
      });
    },
    deleteData(id) {
      this.$store.dispatch("gradeControl/removeMuckType", id)
        .then(() => {
          this.$vs.notify({
            color: "success",
            title: this.$t("Success"),
            text: this.$t("GradeControl.MuckType.LocationDeleted")
          });
        });
    },
    editData(data) {
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    muckTypeUpdated() {
      this.$vs.notify({
        title: this.$t("Success"),
        text: this.$t("SaveSuccess"),
        color: "success",
        iconPack: 'feather',
        icon:'icon-check'
      });

      this.toggleDataSidebar(false);

    },
    muckTypeInserted() {
      this.$vs.notify({
        title: this.$t("Success"),
        text: this.$t("InsertSuccess"),
        color: "success",
        iconPack: 'feather',
        icon:'icon-check'
      });
      this.toggleDataSidebar(false);
    },
    refreshMuckTypeList() {
      this.$store.dispatch("gradeControl/fetchMuckTypeListItems", this.selectedProjectId).then(() => {
        this.$refs.listCard.removeRefreshAnimation();
      });
    }
  },
  created() {
    if (!moduleGradeControl.isRegistered) {
      this.$store.registerModule("gradeControl", moduleGradeControl);
      moduleGradeControl.isRegistered = true;
    }

    this.selectedProjectId = Number(this.$store.state.projectId);
  },
  mounted() {
    if (!this.isMounted) {
      this.$refs.listCard.refreshcard();
    }

    this.isMounted = true;
  }
};
</script>

<style lang="scss">
#data-list-list-view {
.vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 0.8rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 8px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
        width: 50px;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--tbody-table {
      min-width: 200px;
    }

    .vs-table--pagination {
      justify-content: center;
    }

     .con-expand-muckTypes {
     width: 100%;
      .con-btns-muckType {
        display:flex;
        padding:10px;
        padding-bottom:0px;
        justify-content:flex-start;
        align-items:left;
        justify-content:space-between;
        .con-muckTypex {
          .con-muckType-comments {
            padding-left:5px;
          }
        }
      }
    }
  }
}
</style>